import React from "react"
import PropTypes from "prop-types"
import { Dialog, FormGroup } from "@tencent/spaui"
import { withApi } from "@tencent/react-aio"
import PromotedObjectSelect from "@/business-components/sale/PromotedObjectSelect"
import TeamUserSelect from "@/business-components/sale/TeamUserSelect"
import { withAccount } from "@/business-components/operator/account-context"
import message from "@/utils/message"
import _ from "lodash"

const errConfig = {
  adPlatformTypes: { tip: "请选择推广目标", field: "adPlatformTypeErr" },
  // promotedObject: { tip: "请选择投放目标", field: "promotedObjectErr" },
  ownerId: { tip: "请选择跟进人", field: "ownerIdErr" },
}

class PotentialCopyModal extends React.Component {
  static propTypes = {
    lead: PropTypes.object,
    onSubmit: PropTypes.func,
  }

  constructor(props) {
    super(props)
    this.state = {
      show: false,
    }
    this.disabled = false
  }

  componentDidMount() {
    const {
      account: { saleStatus = {} },
    } = this.props
    const { userId } = saleStatus
    this.setState({ ownerId: userId })
  }

  handleChangePromotedObject = (value) => {
    const { adPlatformTypes, promotedObject } = value
    this.setState({
      adPlatformTypes,
      promotedObject,
      adPlatformTypeErr: "",
      promotedObjectErr: "",
    })
  }

  handleOwnerId = (e, ownerId) => {
    this.setState({ ownerId, ownerIdErr: "" })
  }

  onSubmit = () => {
    const { adPlatformTypes, promotedObject, ownerId } = this.state
    const { webApi, lead = {}, onSubmit } = this.props
    const { leadId } = lead
    const verify = this.validateParams()
    if (verify && !this.disabled) {
      const params = {
        intention: {
          adPlatformTypes,
          // promotedObject,
        },
        ownerId,
      }
      this.disabled = true
      webApi
        .copyPotential(leadId)
        .ajaxJson({
          data: params,
        })
        .then((res) => {
          if (res) {
            this.disabled = false
            message.success("成功")
            onSubmit && onSubmit()
          }
        })
        .catch((err) => {
          this.disabled = false
          message.error(err.message)
        })
    }
  }

  validateParams = () => {
    const { adPlatformTypes, promotedObject } = this.state
    let verify = true
    for (let i in errConfig) {
      const { field, tip } = errConfig[i]

      if (!this.state[i]) {
        this.setState({
          [field]: tip,
        })
        verify = false
      } else {
        this.setState({
          [field]: "",
        })
      }
    }
    return verify
  }

  render() {
    const { adPlatformTypes, promotedObject, ownerId, adPlatformTypeErr, ownerIdErr, promotedObjectErr } = this.state
    return (
      <Dialog className="CreateActionRecordModal" title="复制商机" {...this.props} style={{ width: 640 }} onSubmit={this.onSubmit}>
        <p>复制商机将生成一条与当前商机信息一致的另一条商机，ID不同;主要用于不同推广目标的商机/订单跟进。</p>
        <FormGroup className={"required with-select"} error={adPlatformTypeErr || promotedObjectErr}>
          <label>推广目标</label>
          <PromotedObjectSelect adPlatformTypes={adPlatformTypes} promotedObject={promotedObject} onChange={this.handleChangePromotedObject} />
        </FormGroup>
        <FormGroup className={"required with-select"} error={ownerIdErr}>
          <label>请选择跟进人</label>
          <TeamUserSelect value={ownerId} onChange={this.handleOwnerId} />
        </FormGroup>
      </Dialog>
    )
  }
}

export default withApi(withAccount(PotentialCopyModal))
